/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

'use strict';
angular.module('prism-ui.package').controller('LiveClipToolbarController',
    function($scope, $location, PackageUtilService, ModalService, PermissionsService, $q, PackageActionService, PackageResourceFactory,
             PackageLiveClipViewService) {
        var PACKAGE_VIDEO_CLIPS_VIEW_STATE = 'PACKAGE_VIDEO_CLIPS_VIEW_STATE';
        var PACKAGE_AD_HOC_ADD_PARTNERS_VIEW_STATE = 'PACKAGE_AD_HOC_ADD_PARTNERS_VIEW_STATE';
        var CLIP_ACTION_RESET_VIEW_STATE = 'CLIP_ACTION_RESET_VIEW_STATE';
        var CLIP_ACTION_DELIVER_VIEW_STATE = 'CLIP_ACTION_DELIVER_VIEW_STATE';
        var CLIP_ACTION_RE_EXTRACT_VIEW_STATE = 'CLIP_ACTION_RE_EXTRACT_VIEW_STATE';
        var CLIP_ACTION_VALIDATE_VIEW_STATE = 'CLIP_ACTION_VALIDATE_VIEW_STATE';
        var CLIP_ACTION_RETRIEVE_MASTER_MEDIA_VIEW_STATE = 'CLIP_ACTION_RETRIEVE_MASTER_MEDIA_VIEW_STATE';
        var CLIP_ACTION_HIDE_VIEW_STATE = 'CLIP_ACTION_HIDE_VIEW_STATE';
        var CLIP_ACTION_BATCH_MODIFY_METADATA_VIEW_STATE = 'CLIP_ACTION_BATCH_MODIFY_METADATA_VIEW_STATE';
        var CLIP_ACTION_EXPORT_METADATA_VIEW_STATE = 'CLIP_ACTION_EXPORT_METADATA_VIEW_STATE';
        var CLIP_ACTION_GENERATE_DELIVERY_REPORT_VIEW_STATE = 'CLIP_ACTION_GENERATE_DELIVERY_REPORT_VIEW_STATE';
        var self = this;

        self.liveToolbarPerms = {
            clipResetRead: false,
            clipResetWrite: false,
            clipDeliverRead: false,
            clipDeliverWrite: false,
            clipExtractRead: false,
            clipExtractWrite: false,
            clipValidateRead: false,
            clipValidateWrite: false,
            clipMasterMediaRead: false,
            clipMasterMediaWrite: false,
            clipHideRead: false,
            clipHideWrite: false,
            clipBatchModifyRead: false,
            clipBatchModifyWrite: false,
            clipExportMetaRead: false,
            clipExportMetaWrite: false,
            clipDeliveryReportRead: false,
            clipDeliveryReportWrite: false
        };

        self.selectedPackages = [];
        self.viewModel = PackageLiveClipViewService.viewModel;
        self.liveClipActions = PackageActionService.liveClipActions;
        self.showActionsLoading = PackageActionService.actionsLoading;

        self.retrieveClipPermissions = function () {
        	if (self.selectedPackages.length > 0) {
				PackageActionService.actionsLoading = true;
				PackageActionService.checkClipPackagesToEnableActions().then(function () {
					self.actionsLoading = PackageActionService.actionsLoading = false;
				});
			}
		};

        var showLoadingIndicator = function () {
            $scope.$emit('server-busy', {working: true});
        };

        var hideLoadingIndicator = function () {
            $scope.$emit('server-busy', {working: false});
        };

        self.handleSelectedAction = function () {
            PackageActionService.handleSelectedAction(
                self.selectedAction,
                showLoadingIndicator,
                hideLoadingIndicator
            );
            self.selectedAction = null;
        };

        self.includeArchived = false;
        self.unhideInvalid = self.hideInvalid = true;
        var enableHideUnhide = function () {
            var archivedFound = false;
            var unarchivedFound = false;
            if (self.selectedPackages.length === 0 || !self.liveToolbarPerms.clipHideWrite) {
                self.hideInvalid = self.unhideInvalid = true;
                return;
            }

            for (var i = 0; i < self.selectedPackages.length; i++) {
                var pkg = self.selectedPackages[i];
                if (pkg.hidden) {
                    archivedFound = true;
                }
                else {
                    unarchivedFound = true;
                }
                if (unarchivedFound && archivedFound) {
                    self.hideInvalid = self.unhideInvalid = true;
                    return;
                }
            }
            if (unarchivedFound) {
                self.unhideInvalid = true;
                self.hideInvalid = false;
            }
            else {
                self.unhideInvalid = false;
                self.hideInvalid = true;
            }
        };

        self.updateClipList = function () {
            PackageLiveClipViewService.includeHidden = self.includeArchived;
            PackageLiveClipViewService.refreshClips();
        };

        self.disableActionDropdown = function () {
            if($location.search().livePackageId) {
                return (PackageLiveClipViewService.collaboratorsForm && PackageLiveClipViewService.collaboratorsForm.$dirty) ||
                    (PackageLiveClipViewService.metadataForm && PackageLiveClipViewService.metadataForm.$dirty) ||
                    (PackageLiveClipViewService.distributionForm && PackageLiveClipViewService.distributionForm.$dirty) ||
                    (PackageLiveClipViewService.advancedForm && PackageLiveClipViewService.advancedForm.$dirty);
            }
            else {
                return false;
            }
        };

        var enableLiveToolbarItems = function () {
            enableHideUnhide();
        };

        var getPermissions = function () {
            var clipResetReadPromise = PermissionsService.canRead(CLIP_ACTION_RESET_VIEW_STATE);
            var clipResetWritePromise = PermissionsService.canWrite(CLIP_ACTION_RESET_VIEW_STATE);
            var clipDeliverReadPromise = PermissionsService.canRead(CLIP_ACTION_DELIVER_VIEW_STATE);
            var clipDeliverWritePromise = PermissionsService.canWrite(CLIP_ACTION_DELIVER_VIEW_STATE);
            var clipReExtractReadPromise = PermissionsService.canRead(CLIP_ACTION_RE_EXTRACT_VIEW_STATE);
            var clipReExtractWritePromise = PermissionsService.canWrite(CLIP_ACTION_RE_EXTRACT_VIEW_STATE);
            var clipValidateReadPromise = PermissionsService.canRead(CLIP_ACTION_VALIDATE_VIEW_STATE);
            var clipValidateWritePromise = PermissionsService.canWrite(CLIP_ACTION_VALIDATE_VIEW_STATE);
            var clipRetrieveMasterMediaReadPromise = PermissionsService.canRead(CLIP_ACTION_RETRIEVE_MASTER_MEDIA_VIEW_STATE);
            var clipRetrieveMasterMediaWritePromise = PermissionsService.canWrite(CLIP_ACTION_RETRIEVE_MASTER_MEDIA_VIEW_STATE);
            var clipHideReadPromise = PermissionsService.canRead(CLIP_ACTION_HIDE_VIEW_STATE);
            var clipHideWritePromise = PermissionsService.canWrite(CLIP_ACTION_HIDE_VIEW_STATE);
            var clipBatchModifyClipsReadPromise = PermissionsService.canRead(CLIP_ACTION_BATCH_MODIFY_METADATA_VIEW_STATE);
            var clipBatchModifyClipsWritePromise = PermissionsService.canWrite(CLIP_ACTION_BATCH_MODIFY_METADATA_VIEW_STATE);
            var clipExportMetadataReadPromise = PermissionsService.canRead(CLIP_ACTION_EXPORT_METADATA_VIEW_STATE);
            var clipExportMetadataWritePromise = PermissionsService.canWrite(CLIP_ACTION_EXPORT_METADATA_VIEW_STATE);
            var clipDeliveryReportReadPromise = PermissionsService.canRead(CLIP_ACTION_GENERATE_DELIVERY_REPORT_VIEW_STATE);
            var clipDeliveryReportWritePromise = PermissionsService.canWrite(CLIP_ACTION_GENERATE_DELIVERY_REPORT_VIEW_STATE);

            $q.all({
                clipResetRead: clipResetReadPromise,
                clipResetWrite: clipResetWritePromise,
                clipDeliverRead: clipDeliverReadPromise,
                clipDeliverWrite: clipDeliverWritePromise,
                clipExtractRead: clipReExtractReadPromise,
                clipExtractWrite: clipReExtractWritePromise,
                clipValidateRead: clipValidateReadPromise,
                clipValidateWrite: clipValidateWritePromise,
                clipMasterMediaRead: clipRetrieveMasterMediaReadPromise,
                clipMasterMediaWrite: clipRetrieveMasterMediaWritePromise,
                clipHideRead: clipHideReadPromise,
                clipHideWrite: clipHideWritePromise,
                clipBatchModifyRead: clipBatchModifyClipsReadPromise,
                clipBatchModifyWrite: clipBatchModifyClipsWritePromise,
                clipExportMetaRead: clipExportMetadataReadPromise,
                clipExportMetaWrite: clipExportMetadataWritePromise,
                clipDeliveryReportRead: clipDeliveryReportReadPromise,
                clipDeliveryReportWrite: clipDeliveryReportWritePromise}).then(function(perms) {
                self.liveToolbarPerms.clipResetRead = perms.clipResetRead;
                self.liveToolbarPerms.clipResetWrite = perms.clipResetWrite;
                self.liveToolbarPerms.clipDeliverRead = perms.clipDeliverRead;
                self.liveToolbarPerms.clipDeliverWrite = perms.clipDeliverWrite;
                self.liveToolbarPerms.clipExtractRead = perms.clipExtractRead;
                self.liveToolbarPerms.clipExtractWrite = perms.clipExtractWrite;
                self.liveToolbarPerms.clipValidateRead = perms.clipValidateRead;
                self.liveToolbarPerms.clipValidateWrite = perms.clipValidateWrite;
                self.liveToolbarPerms.clipMasterMediaRead = perms.clipMasterMediaRead;
                self.liveToolbarPerms.clipMasterMediaWrite = perms.clipMasterMediaWrite;
                self.liveToolbarPerms.clipHideRead = perms.clipHideRead;
                self.liveToolbarPerms.clipHideWrite = perms.clipHideWrite;
                self.liveToolbarPerms.clipBatchModifyRead = perms.clipBatchModifyRead;
                self.liveToolbarPerms.clipBatchModifyWrite = perms.clipBatchModifyWrite;
                self.liveToolbarPerms.clipExportMetaRead = perms.clipExportMetaRead;
                self.liveToolbarPerms.clipExportMetaWrite = perms.clipExportMetaWrite;
                self.liveToolbarPerms.clipDeliveryReportRead = perms.clipDeliveryReportRead;
                self.liveToolbarPerms.clipDeliveryReportWrite = perms.clipDeliveryReportWrite;

                self.selectedPackages = [];
                enableLiveToolbarItems();
            });
        };

        self.hideMessage = 'Are you sure you want to hide ';
        self.unhideMessage = 'Are you sure you want to unhide ';
        self.openConfirmModal = function (messageText, title, handler) {
            if (self.selectedPackages.length === 1) {
                messageText += self.selectedPackages[0].name + '?';
                title += self.selectedPackages[0].name + '?';
            }
            else {
                messageText += 'these items?';
                title += 'items?';
            }
            ModalService.showMessageModal({
                messageText: messageText,
                pullCancelLeft: true,
                title: title,
                windowClass: 'confirm-modal-sm',
                showOK: true
            }, handler);
        };

        self.toggleArchiveFlag = function () {
            self.unhideInvalid = self.hideInvalid = true;
            $scope.$emit('server-busy', {working: true});
            var promises = [];
            angular.forEach(self.selectedPackages, function (packageObj) {
                var pkg = PackageResourceFactory.toggleArchive({id: packageObj.id}).$promise;
                promises.push(pkg);
            });
            $q.all(promises).then(function (pkgs) {
                PackageLiveClipViewService.refreshClips();
                $scope.$emit('server-busy', {working: false});
            });
        };

        self.prevPageDisabled = function () {
            return (self.pagingOptions.pageData.length) ? self.pagingOptions.currentPage === 1 && self.pagingOptions.currentPageItemIndex === 0 : true;
        };

        self.prevPageClickHandler = function () {
            if (!self.prevPageDisabled() && self.prevHandler) {
                self.prevHandler();
            }
        };

        self.nextPageDisabled = function () {
            return (self.pagingOptions.pageData.length) ? self.pagingOptions.currentPage === self.pagingOptions.totalPages &&
            self.pagingOptions.currentPageItemIndex === self.pagingOptions.pageSize : true;
        };

        self.nextPageClickHandler = function () {
            if (!self.nextPageDisabled() && self.nextHandler) {
                self.nextHandler();
            }
        };

        self.closeClickHandler = function () {
            if (PackageUtilService.postCloseUpdate) {
                PackageUtilService.postCloseUpdate();
            }
            if (self.closeHandler) {
                self.closeHandler();
            }
        };

        $scope.$watch(function () {
            return PackageUtilService.editorForm;
        }, function () {
            self.editorForm = PackageUtilService.editorForm;
        });

        $scope.$watch(function () {
            return self.includeArchived;
        }, function () {
            PackageLiveClipViewService.includeHidden = self.includeArchived;
        });

        $scope.$watchCollection(function () {
            return PackageActionService.selectedPackages;
        }, function () {
            self.selectedPackages = PackageActionService.selectedPackages;
            enableLiveToolbarItems();
        });

        $scope.$watch(function () {
            return $location.search();
        }, function () {
            if($location.search().livePackageId) {
                self.liveClipActions = PackageActionService.liveClipEditorActions;
            }
            else {
                self.liveClipActions = PackageActionService.liveClipActions;
            }
        }, true);

	    $scope.$watch(function () {
		    return PackageActionService.actionsLoading;
	    }, function () {
		    self.showActionsLoading = PackageActionService.actionsLoading;
	    });

        getPermissions();

    });
